import { Button, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface HiddenElementsButtonProps {
  numHiddenElements: number;
  onClearHidden: () => void;
}

export default function HiddenElementsButton({
  numHiddenElements,
  onClearHidden,
}: HiddenElementsButtonProps) {
  const { t } = useTranslation('project');
  const activeIconColor = useColorModeValue('teal.500', 'teal.200');

  if (numHiddenElements === 0) {
    return null;
  }

  return (
    <Tooltip label={t('viewer-interactions.clear-hidden')}>
      <Button
        colorScheme="teal"
        variant="toggle"
        isActive
        size="xs"
        color={activeIconColor}
        onClick={onClearHidden}
      >
        {t('viewer-interactions.hidden-elements', { numHiddenElements })}
      </Button>
    </Tooltip>
  );
}
